import React from "react";
import Dashboard from "../Dashboard";

const Setting = () => {
  return <Dashboard>Setting page</Dashboard>;
};

export default Setting;
